import { createGlobalStyle } from 'styled-components';
import theme from './theme';

const GlobalStyles = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap');
    
    * {
      box-sizing: border-box;
    }
    
    html {
      margin: 0;
      padding: 0;
    }
    
    body {
      margin: 0;
      padding: 0;
      background: ${theme.colors.light};
      color: ${theme.colors.dark};
      font-family: ${theme.fonts.default};
      font-weight: 400;
      font-size: ${theme.fontSizes.default};
      line-height: 1.3rem;
      text-rendering: optimizeLegibility;
      -moz-osx-font-smoothing: grayscale;
      font-smoothing: antialiased;
      -webkit-font-smoothing: antialiased;
      text-shadow: rgba(0, 0, 0, .01) 0 0 1px;
      
      &.ReactModal__Body--open {
        position: fixed;
        width: 100%;
        &:not(.modal-search) #app {
          filter: blur(10px);
        }
        &.modal-search {
          .app__header {
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 10;
          }
          .app__main {
            filter: blur(10px);
            position: relative;
          }
          .Overlay {
            top: 67px;
            padding: 0;
          }
          .Modal {
            padding: 0;
            background: none;
            box-shadow: none;f
          }
          @media (max-width: ${theme.breakpoints.desktop}) {
            .Overlay {
              top: 102px;
            }
          }
        }
      }
    }
    
    a {
      text-decoration: underline;
      color: inherit;
    }
    
    p {
      margin: 0 0 1rem 0;
    }
    
    #app {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-height: 100vh;
    }
    
    @media print {
      .print-hide {
        display: none !important;
      }
      body {
        padding-top: 0.5rem;
      }
    }
    
  `;

export default GlobalStyles;
